// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as BecomeRouteImport } from './routes/become'
import { Route as GuestRouteImport } from './routes/_guest'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as GuestIndexRouteImport } from './routes/_guest.index'
import { Route as GuestSignupRouteImport } from './routes/_guest.signup'
import { Route as GuestSigninRouteImport } from './routes/_guest.signin'
import { Route as GuestReset_passwordRouteImport } from './routes/_guest.reset_password'
import { Route as AuthLayoutRouteImport } from './routes/_auth._layout'
import { Route as AuthLayoutReportRouteImport } from './routes/_auth._layout.report'
import { Route as AuthLayoutReferralRouteImport } from './routes/_auth._layout.referral'
import { Route as AuthLayoutProfileRouteImport } from './routes/_auth._layout.profile'
import { Route as AuthLayoutPostbacks_logsRouteImport } from './routes/_auth._layout.postbacks_logs'
import { Route as AuthLayoutPaymentsRouteImport } from './routes/_auth._layout.payments'
import { Route as AuthLayoutDashboardRouteImport } from './routes/_auth._layout.dashboard'
import { Route as AuthLayoutOffersIndexRouteImport } from './routes/_auth._layout.offers.index'
import { Route as AuthLayoutOffersIdRouteImport } from './routes/_auth._layout.offers_.$id'
import { Route as AuthLayoutOffersReportIdRouteImport } from './routes/_auth._layout.offers_.report.$id'

const BecomeRoute = BecomeRouteImport.update({
            id: '/become',path: '/become',getParentRoute: () => rootRouteImport
          })
const GuestRoute = GuestRouteImport.update({
            id: '/_guest',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/_auth',getParentRoute: () => rootRouteImport
          })
const GuestIndexRoute = GuestIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => GuestRoute
          })
const GuestSignupRoute = GuestSignupRouteImport.update({
            id: '/signup',path: '/signup',getParentRoute: () => GuestRoute
          })
const GuestSigninRoute = GuestSigninRouteImport.update({
            id: '/signin',path: '/signin',getParentRoute: () => GuestRoute
          })
const GuestReset_passwordRoute = GuestReset_passwordRouteImport.update({
            id: '/reset_password',path: '/reset_password',getParentRoute: () => GuestRoute
          })
const AuthLayoutRoute = AuthLayoutRouteImport.update({
            id: '/_layout',getParentRoute: () => AuthRoute
          })
const AuthLayoutReportRoute = AuthLayoutReportRouteImport.update({
            id: '/report',path: '/report',getParentRoute: () => AuthLayoutRoute
          })
const AuthLayoutReferralRoute = AuthLayoutReferralRouteImport.update({
            id: '/referral',path: '/referral',getParentRoute: () => AuthLayoutRoute
          })
const AuthLayoutProfileRoute = AuthLayoutProfileRouteImport.update({
            id: '/profile',path: '/profile',getParentRoute: () => AuthLayoutRoute
          })
const AuthLayoutPostbacks_logsRoute = AuthLayoutPostbacks_logsRouteImport.update({
            id: '/postbacks_logs',path: '/postbacks_logs',getParentRoute: () => AuthLayoutRoute
          })
const AuthLayoutPaymentsRoute = AuthLayoutPaymentsRouteImport.update({
            id: '/payments',path: '/payments',getParentRoute: () => AuthLayoutRoute
          })
const AuthLayoutDashboardRoute = AuthLayoutDashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => AuthLayoutRoute
          })
const AuthLayoutOffersIndexRoute = AuthLayoutOffersIndexRouteImport.update({
            id: '/offers/',path: '/offers/',getParentRoute: () => AuthLayoutRoute
          })
const AuthLayoutOffersIdRoute = AuthLayoutOffersIdRouteImport.update({
            id: '/offers_/$id',path: '/offers/$id',getParentRoute: () => AuthLayoutRoute
          })
const AuthLayoutOffersReportIdRoute = AuthLayoutOffersReportIdRouteImport.update({
            id: '/offers_/report/$id',path: '/offers/report/$id',getParentRoute: () => AuthLayoutRoute
          })





const AuthLayoutRouteChildren = {
  AuthLayoutDashboardRoute: AuthLayoutDashboardRoute,AuthLayoutPaymentsRoute: AuthLayoutPaymentsRoute,AuthLayoutPostbacks_logsRoute: AuthLayoutPostbacks_logsRoute,AuthLayoutProfileRoute: AuthLayoutProfileRoute,AuthLayoutReferralRoute: AuthLayoutReferralRoute,AuthLayoutReportRoute: AuthLayoutReportRoute,AuthLayoutOffersIdRoute: AuthLayoutOffersIdRoute,AuthLayoutOffersIndexRoute: AuthLayoutOffersIndexRoute,AuthLayoutOffersReportIdRoute: AuthLayoutOffersReportIdRoute
}

const AuthLayoutRouteWithChildren = AuthLayoutRoute._addFileChildren(AuthLayoutRouteChildren)



const AuthRouteChildren = {
  AuthLayoutRoute: AuthLayoutRouteWithChildren
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)




const GuestRouteChildren = {
  GuestReset_passwordRoute: GuestReset_passwordRoute,GuestSigninRoute: GuestSigninRoute,GuestSignupRoute: GuestSignupRoute,GuestIndexRoute: GuestIndexRoute
}

const GuestRouteWithChildren = GuestRoute._addFileChildren(GuestRouteChildren)

const rootRouteChildren = {
  AuthRoute: AuthRouteWithChildren,GuestRoute: GuestRouteWithChildren,BecomeRoute: BecomeRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)